import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useOutletContext, useParams } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AppDashboard from "./pages/AppDashboard";
import AppSummary from "./pages/AppSummary";
import AppSubscriptions from "./pages/AppSubscriptions";
import AppTransactions from "./pages/AppTransactions";
import AppSettings from "./pages/AppSettings";
import IntegrationGuide from "./pages/IntegrationGuide";
import RazorpaySubscriptions from "./pages/RazorpaySubscriptions";
import RazorpayPayments from "./pages/RazorpayPayments";
import AdminLayout from "./pages/AdminLayout";
import AdminUsers from "./pages/AdminUsers";
import AdminApps from "./pages/AdminApps";
import AdminAppUsers from "./pages/AdminAppUsers";
import AdminRedis from "./pages/AdminRedis";
import { getToken } from "./api";

function ProtectedRoute({ children }) {
  const token = getToken();
  if (!token) return <Navigate to="/" replace />;
  return children;
}

// Redirects the index route to the correct gateway landing page
function AppIndex() {
  const { app } = useOutletContext();
  const { appId } = useParams();
  if (!app) return null;
  if (app.phonepe_enabled) return <AppSummary />;
  if (app.razorpay_enabled) return <Navigate to={`/apps/${appId}/rz-subscriptions`} replace />;
  return <Navigate to={`/apps/${appId}/settings`} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* User login at base route */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Navigate to="/" replace />} />

        {/* User area */}
        <Route
          path="/dashboard"
          element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
        />
        <Route
          path="/apps/:appId"
          element={<ProtectedRoute><AppDashboard /></ProtectedRoute>}
        >
          <Route index element={<AppIndex />} />

          {/* PhonePe routes */}
          <Route path="subscriptions" element={<AppSubscriptions />} />
          <Route path="transactions" element={<AppTransactions />} />

          {/* Razorpay routes */}
          <Route path="rz-subscriptions" element={<RazorpaySubscriptions />} />
          <Route path="rz-payments" element={<RazorpayPayments />} />

          {/* Shared */}
          <Route path="settings" element={<AppSettings />} />
          <Route path="integration-guide" element={<IntegrationGuide />} />
        </Route>

        {/* Admin area — AdminLayout gates on the shared session: it redirects an
            anonymous visitor to the login page and a non-admin to /dashboard. */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/apps" replace />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="apps" element={<AdminApps />} />
          <Route path="apps/:appId" element={<AdminAppUsers />} />
          <Route path="redis" element={<AdminRedis />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
